import './index.css';
// init Sentry
import './instrument';

import { StytchB2BProvider, StytchB2BClient } from '@stytch/react/b2b';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router';
import App from './App';
import {
  stytchClientOptions,
  stytchSessionDurationMinutes,
} from './utils/stytchConfig.ts';

const root = createRoot(document.getElementById('root')!);

// Initialize Stytch
const stytch = new StytchB2BClient(
  import.meta.env.VITE_STYTCH_PUBLIC_TOKEN,
  stytchClientOptions,
);

const extendSession = () => {
  if (stytch.session.getSync()) {
    stytch.session.authenticate({
      session_duration_minutes: stytchSessionDurationMinutes,
    });
  }
};

// Extend the session's lifetime every 10 minutes as long as a window is open
const extendSessionInterval = setInterval(extendSession, 600000);
window.addEventListener('beforeunload', () => {
  clearInterval(extendSessionInterval);
});

root.render(
  <StrictMode>
    <StytchB2BProvider stytch={stytch}>
      <Router>
        <App />
      </Router>
    </StytchB2BProvider>
  </StrictMode>,
);
